import Box from "@memorang/ui/components/Box";
import { PodcastProgressBar } from "@memorang/ui/components/PodcastProgressBar";
import { useAppTheme } from "@memorang/ui/useAppTheme";
import { usePathname, useRouter } from "expo-router";
import { IconButton, Text } from "react-native-paper";
import usePodcastPlayer from "../hooks/usePodcastPlayer";
import { usePodcastPlayerStore } from "../hooks/usePodcastPlayerStore";
import { usePodcasts } from "../hooks/usePodcasts";
import { formatPodcastDuration } from "../utils";

const FixedPodcastPlayer = () => {
	const router = useRouter();
	const currentTrackInfo = usePodcastPlayerStore(
		(store) => store.currentTrackInfo,
	);
	const isPlaying = usePodcastPlayerStore((store) => store.isPlaying);
	const isFirstTrack = usePodcastPlayerStore((store) => store.isFirstTrack);
	const endOfQueue = usePodcastPlayerStore((store) => store.endOfQueue);
	const { playPause, skipToPrevious, skipToNext, seekTo, progress } =
		usePodcastPlayer();
	const { podcasts } = usePodcasts();
	const theme = useAppTheme();

	const iconColor = theme.colors.onPrimary;
	const containerColor = theme.colors.primary;

	const pathname = usePathname();

	const handleSkipToPrevious = async () => {
		if (isPlaying) {
			await playPause();
		}
		const track = await skipToPrevious();
		if (track?.album && pathname.includes("/podcasts/")) {
			const podcast = podcasts.find((p) => p.id === Number(track.album));
			if (podcast?.id) {
				router.replace(`/podcasts/${podcast.id}`);
			}
		}
	};

	const handleSkipToNext = async () => {
		if (isPlaying) {
			await playPause();
		}
		const track = await skipToNext();
		if (track?.album && pathname.includes("/podcasts/")) {
			const podcast = podcasts.find((p) => p.id === Number(track.album));
			if (podcast?.id) {
				router.replace(`/podcasts/${podcast.id}`);
			}
		}
	};

	if (!currentTrackInfo) {
		return null;
	}

	return (
		<Box paddingVertical={8} gap={8}>
			<Box paddingHorizontal={16}>
				<PodcastProgressBar
					position={progress.position}
					duration={progress.duration}
					onSeek={seekTo}
				/>
				<Box flexDirection="row" justifyContent="space-between" width="100%">
					<Text
						variant="bodySmall"
						style={{ color: theme.colors.onSurfaceVariant }}
					>
						{formatPodcastDuration(progress.position)}
					</Text>
					<Text
						variant="bodySmall"
						style={{ color: theme.colors.onSurfaceVariant }}
					>
						{formatPodcastDuration(progress.duration)}
					</Text>
				</Box>
			</Box>
			<Box flexDirection="row" alignItems="center" gap={8} alignSelf="center">
				<IconButton
					icon="skip-previous"
					mode="contained-tonal"
					size={20}
					onPress={handleSkipToPrevious}
					disabled={isFirstTrack}
					style={{ margin: 0 }}
				/>
				<IconButton
					icon={isPlaying ? "pause" : "play"}
					iconColor={iconColor}
					containerColor={containerColor}
					size={20}
					onPress={playPause}
					style={{ margin: 0 }}
				/>
				<IconButton
					icon="skip-next"
					mode="contained-tonal"
					size={20}
					onPress={handleSkipToNext}
					disabled={endOfQueue}
					style={{ margin: 0 }}
				/>
			</Box>
		</Box>
	);
};

export default FixedPodcastPlayer;
